import Transform from "@ember-data/serializer/transform";

export default class SurgerySurgeriesTransform extends Transform {
  override deserialize(serialized) {
    serialized?.forEach(surgery => {
      // Make sure date are of type Date and not string.
      // This is useful when passing the date in a DatePicker, which must have a Date and not a string.
      if (surgery.date) {
        surgery.date = new Date(surgery.date);
      }
      if (surgery.consultation) {
        surgery.consultation = new Date(surgery.consultation);
      }
      if (surgery.postConsultation) {
        surgery.postConsultation = new Date(surgery.postConsultation);
      }
    });
    return serialized;
  }

  override serialize(deserialized) {
    return deserialized;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "surgery-surgeries": SurgerySurgeriesTransform;
  }
}
